import { SiderState } from './stateI'

const initialSiderState: SiderState = {
  selectedItem: '',
}

export default initialSiderState
